import { createEvent, restore, sample } from 'effector'
import { fx, path } from 'src/libs'
import { languages } from '../../../../../libs/languages'
import { WebBannerGroupItem } from '../types'
import { toPath } from '../../../../../features/router'
import { getOffers } from '../../offers/list/model'
import { Offer } from '../../offers/list/types'

export const offersByLangMounted = createEvent<{ lang: string }>()

export const setWebBannerGroupForm = createEvent<WebBannerGroupItem>()

export const submitCreateWebBannerGroup = createEvent<WebBannerGroupItem>()

export const $webBannerGroup = restore(setWebBannerGroupForm, {
  lang: `${languages[0].value}`,
  title: '',
  offerId: 0,
  isVisible: true,
})

export const $offersByLang = restore<Offer[]>(
  getOffers.doneData.map((a) => a.body.items),
  [],
)

export const createWebBannerGroup = fx<WebBannerGroupItem, void>({
  method: 'POST',
  url: '/partner/material/website_banner',
})

sample({
  clock: submitCreateWebBannerGroup,
  fn: (webBannerGroup) => {
    return {
      url: `/partner/material/website_banner`,
      body: { ...webBannerGroup },
    }
  },
  target: createWebBannerGroup,
})

sample({
  clock: [createWebBannerGroup.doneData],
  target: toPath.prepend(path.ib.ad.banners.entry),
})

sample({
  // @ts-ignore
  clock: offersByLangMounted,
  fn: ({ lang }) => {
    let query = {
      lang,
    }

    return {
      query,
    }
  },
  target: getOffers,
})
